export class Option {
    get strikePricePutStr() {
        if (isValidString(this.version)) {
            return `${this.strikePrice} P (${this.version})`;
        }
        else {
            return `${this.strikePrice} P`;
        }
    }
    get strikePriceCallStr() {
        if (isValidString(this.version)) {
            return `${this.strikePrice} C (${this.version})`;
        }
        else {
            return `${this.strikePrice} C`;
        }
    }
    get underlierDisplayName() {
        var _a;
        let underlierDisaplyName = null;
        const putUnderlier = (_a = this.put) === null || _a === void 0 ? void 0 : _a.ForwardBaseInstrument;
        if (!isNullOrUndefined(putUnderlier)) {
            underlierDisaplyName = putUnderlier.DisplayName();
        }
        else if (!isNullOrUndefined(this.call)) {
            underlierDisaplyName = this.call.DisplayName();
        }
        if (isValidString(underlierDisaplyName)) {
            return isValidString(this.version) ? `${underlierDisaplyName}${this.version}` : underlierDisaplyName;
        }
        else {
            return null;
        }
    }
    constructor(version, strikePrice, put, call, putEnabled, callEnabled) {
        this.version = version;
        this.strikePrice = strikePrice;
        this.put = put;
        this.call = call;
        this.putEnabled = putEnabled;
        this.callEnabled = callEnabled;
    }
}
export function compareOptions(a, b) {
    const aStrikePrice = a.strikePrice;
    const bStrikePrice = b.strikePrice;
    const strikePriceResult = aStrikePrice - bStrikePrice;
    if (strikePriceResult !== 0) {
        return strikePriceResult;
    }
    const aVersion = isValidString(a.version) ? a.version : '';
    const bVersion = isValidString(b.version) ? b.version : '';
    return aVersion.localeCompare(bVersion);
}
